const topics = [
  { label: '韩漫推荐', hot: '128万讨论' },
  { label: '恋爱漫画', hot: '115万讨论' },
  { label: '日漫经典', hot: '103万讨论' },
  { label: '奇幻冒险', hot: '96万讨论' },
  { label: '国漫崛起', hot: '89万讨论' },
  { label: '治愈日常', hot: '82万讨论' },
  { label: '仙侠修真', hot: '76万讨论' },
  { label: '悬疑推理', hot: '68万讨论' },
  { label: '宫廷古风', hot: '61万讨论' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">热门话题</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">妖精漫画网读者正在热议的漫画话题，加入讨论发现更多好看的作品</p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((t) => (
            <a
              key={t.label}
              href="#cards"
              className="group px-5 py-3 bg-background-100 hover:bg-primary-50 border border-background-200/60 hover:border-primary-300 rounded-full transition-all"
            >
              <span className="font-heading text-sm text-foreground-800 group-hover:text-primary-700 whitespace-nowrap">
                # {t.label}
              </span>
              <span className="ml-2 text-xs text-foreground-500">{t.hot}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}